export default "__VITE_ASSET__xHpr6KfJ__"